import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from './env/locales/en/translation.json';
import es from './env/locales/es/translation.json';

const resources = {
  en: {
    translation: en
  },
  es: {
    translation: es
  }
};


i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    resources,
    react: {
      useSuspense: false
    }
  });


export default i18n;

